import * as faceapi from "face-api.js"

const MODELS_URL = "/models"
let areModelsLoaded = false

export const loadFaceApiModels = async () => {
  if (areModelsLoaded) {
    return
  }

  try {
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODELS_URL),
      faceapi.nets.faceExpressionNet.loadFromUri(MODELS_URL),
    ])
    areModelsLoaded = true
    console.log("Modelos da face-api carregados.")
  } catch (error) {
    console.error("Erro ao carregar modelos da face-api:", error)
    throw new Error("Falha ao carregar os modelos de IA.")
  }
}
